/**
 * TSV – Klarna PDP Widget (cart-safe, locale-aware)
 * Extracted from theme.liquid for conditional loading on product pages only.
 */
(function () {
  // Build locale like "en-IE" from the page context
  var shopLocale = document.documentElement.lang || 'en';
  var LOCALE = (function(){
    // The platform sets <html lang="en-IE"> etc.
    if (shopLocale.indexOf('-') !== -1) return shopLocale;
    // fallback
    return 'en-IE';
  })();

  // PDP selectors
  var TOTAL_SEL = '#bottomtitle__total__price';
  var RADIO_SEL = 'input[name="cb"]';

  // Klarna placement selector (PDP only — cart is excluded below)
  var PLACEMENT_SEL = [
    'klarna-placement[data-key*="credit"]',
    'klarna-placement[data-key*="promotion"]',
    'klarna-placement[data-key*="badge"]',
    '.klarna-placement[data-key*="credit"]',
    '.klarna-placement[data-key*="promotion"]',
    '.klarna-placement[data-key*="badge"]'
  ].join(',');

  // --- helpers ---
  function parseEuro(txt){
    if (!txt) return null;
    var s = (''+txt).replace(/\s/g,'').replace(/[^0-9,.\-]/g,'');
    if (s.indexOf(',')>-1 && s.indexOf('.')>-1){
      if (s.lastIndexOf(',') < s.lastIndexOf('.')) s = s.replace(/,/g,'');
      else s = s.replace(/\./g,'').replace(',', '.');
    } else if (s.indexOf(',')>-1){ s = s.replace(',', '.'); }
    var n = parseFloat(s);
    return isNaN(n) ? null : n;
  }
  function toCents(n){ return Math.round(n * 100); }
  function toInt(v, d){ v = parseInt(v, 10); return isNaN(v) ? d : v; }

  // Fallback: compute from Pumper config when visible total isn't ready
  function readTotalFromConfigCents(){
    var baseCents = toInt((document.getElementById('prvw_singleProductPrice')||{}).value, NaN);
    if (isNaN(baseCents)) return null;

    function cleanNumList(node){
      if (!node) return [];
      return node.textContent.split(',').map(function(x){
        x = x.replace(/[^\d.-]/g,''); var n = parseFloat(x); return isNaN(n)?null:n;
      }).filter(function(n){ return n!==null; });
    }
    function cleanList(node){
      if (!node) return [];
      return node.textContent.split(',').map(function(x){return x.replace(/\s+/g,'').toLowerCase();}).filter(Boolean);
    }

    var qtys      = cleanNumList(document.getElementById('prvw_dynamic_quantity'));
    var types     = cleanList(document.getElementById('prvw_dynamic_price'));
    var discounts = cleanNumList(document.getElementById('prvw_dynamic_discount'));

    var r = document.querySelector(RADIO_SEL + ':checked') || document.querySelector(RADIO_SEL);
    var qty = toInt(r && r.value, 1);

    var idx  = Math.max(0, qtys.indexOf(qty));
    var type = (types[idx] || 'default');
    var disc = discounts[idx] || 0;

    var perEach = (type === 'percentage') ? Math.round(baseCents * (100 - disc) / 100) : baseCents;
    return perEach * qty;
  }

  // Prefer visible total; else fallback
  function readTotalCents(){
    var el = document.querySelector(TOTAL_SEL);
    var vis = el ? parseEuro(el.textContent) : null;
    if (vis != null) return toCents(vis);
    return readTotalFromConfigCents();
  }

  // Never touch Klarna placements in the cart drawer
  function isCartPlacement(node){
    if (!node || node.nodeType !== 1) return false;
    if (node.getAttribute('data-klarna-scope') === 'cart') return true;
    if (node.closest && node.closest('cart-drawer')) return true;
    return false;
  }

  // Set amount + locale on PDP placements only
  function touchPlacements(cents){
    var nodes = document.querySelectorAll(PLACEMENT_SEL);
    if (!nodes.length) return false;
    var touched = false;
    nodes.forEach(function(p){
      if (isCartPlacement(p)) return;
      if (!p.getAttribute('data-locale')) p.setAttribute('data-locale', LOCALE);
      p.setAttribute('data-purchase-amount', String(cents));
      touched = true;
    });
    return touched;
  }

  function refresh(){
    window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
    window.KlarnaOnsiteService.push({ event: 'refresh-placements' });
  }

  function updateOnce(){
    var cents = readTotalCents();
    if (cents == null) return false;
    var ok = touchPlacements(cents);
    if (ok) refresh();
    return ok;
  }

  // Short burst to beat async redraws
  function updateBurst(){
    [0, 80, 160, 320, 640, 1000, 1500].forEach(function(ms){ setTimeout(updateOnce, ms); });
  }

  // Watch PDP Klarna placements for internal re-renders (skip cart)
  function attachPlacementObservers(){
    document.querySelectorAll(PLACEMENT_SEL).forEach(function(p){
      if (isCartPlacement(p) || p.__klarnaObserved) return;
      p.__klarnaObserved = true;
      var mo = new MutationObserver(function(){ updateBurst(); });
      mo.observe(p, { childList:true, subtree:true });
    });
  }

  function bind(){
    // Bundle radio changes
    document.addEventListener('change', function(e){
      if (e.target && e.target.matches(RADIO_SEL)) updateBurst();
    }, true);

    // Visible total updates
    var t = document.querySelector(TOTAL_SEL);
    if (t){
      var mo = new MutationObserver(function(){ updateBurst(); });
      mo.observe(t, { childList:true, subtree:true, characterData:true });
    } else {
      var mo2 = new MutationObserver(function(){
        var el = document.querySelector(TOTAL_SEL);
        if (el){
          mo2.disconnect();
          var mo3 = new MutationObserver(function(){ updateBurst(); });
          mo3.observe(el, { childList:true, subtree:true, characterData:true });
          updateBurst();
        }
      });
      mo2.observe(document.body, { childList:true, subtree:true });
      // Safety: disconnect if total element never appears (e.g. not a product page)
      setTimeout(function(){ mo2.disconnect(); }, 30000);
    }

    // New Klarna placements injected later (apps/sections)
    var moPlacements = new MutationObserver(function(muts){
      var needs = false;
      muts.forEach(function(m){
        Array.from(m.addedNodes||[]).forEach(function(n){
          if (n.nodeType === 1 && (n.matches && (n.matches(PLACEMENT_SEL) || (n.querySelector && n.querySelector(PLACEMENT_SEL))))) {
            needs = true;
          }
        });
      });
      if (needs){ attachPlacementObservers(); updateBurst(); }
    });
    moPlacements.observe(document.body, { childList:true, subtree:true });

    // Reassert on focus/visibility changes
    window.addEventListener('focus', updateBurst);
    document.addEventListener('visibilitychange', function(){
      if (document.visibilityState === 'visible') updateBurst();
    });

    // After full load (late app inits)
    window.addEventListener('load', function(){ updateBurst(); });

    attachPlacementObservers();
  }

  function start(){
    bind();

    // Wait for Klarna + amount, then do a burst
    var tries = 0;
    (function wait(){
      tries++;
      var osmReady = !!window.KlarnaOnsiteService;
      var haveAnyAmount = readTotalCents() != null;
      if (osmReady && haveAnyAmount) updateBurst();
      else if (tries < 180) setTimeout(wait, 100);
      else updateBurst();
    })();

    // Watchdog for first ~20s to suppress late flickers
    var watchdog = setInterval(function(){
      updateOnce();
      attachPlacementObservers();
    }, 750);
    setTimeout(function(){ clearInterval(watchdog); }, 20000);
  }

  if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', start);
  else start();
})();